var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 160,
    viewBox: "0 0 164 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.048 119H5.65709C4.66383 119 3.85254 119.899 3.85254 121C3.85254 122.101 4.66383 123 5.65709 123H38.048C39.0412 123 39.8525 122.101 39.8525 121C39.8525 119.899 39.0412 119 38.048 119Z",
    fill: "#D7D7DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.048 119H5.65709C4.66383 119 3.85254 119.899 3.85254 121C3.85254 122.101 4.66383 123 5.65709 123H38.048C39.0412 123 39.8525 122.101 39.8525 121C39.8525 119.899 39.0412 119 38.048 119Z",
    fill: "url(#paint0_linear_22134_59490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6257 109H21.3989C20.7877 109 20.2891 109.499 20.2891 110.11C20.2891 110.721 20.7877 111.22 21.3989 111.22H47.6257C48.237 111.22 48.7356 110.721 48.7356 110.11C48.7356 109.499 48.237 109 47.6257 109Z",
    fill: "#D7D7DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6257 109H21.3989C20.7877 109 20.2891 109.499 20.2891 110.11C20.2891 110.721 20.7877 111.22 21.3989 111.22H47.6257C48.237 111.22 48.7356 110.721 48.7356 110.11C48.7356 109.499 48.237 109 47.6257 109Z",
    fill: "url(#paint1_linear_22134_59490)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.814 133H81.8911C80.7691 133 79.8525 133.899 79.8525 135C79.8525 136.101 80.7691 137 81.8911 137H140.814C141.936 137 142.853 136.101 142.853 135C142.853 133.899 141.936 133 140.814 133Z",
    fill: "#D7D7DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.814 133H81.8911C80.7691 133 79.8525 133.899 79.8525 135C79.8525 136.101 80.7691 137 81.8911 137H140.814C141.936 137 142.853 136.101 142.853 135C142.853 133.899 141.936 133 140.814 133Z",
    fill: "url(#paint2_linear_22134_59490)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.302 142.211H91.9995C91.3883 142.211 90.8896 142.71 90.8896 143.321C90.8896 143.932 91.3883 144.431 91.9995 144.431H108.302C108.913 144.431 109.412 143.932 109.412 143.321C109.412 142.71 108.913 142.211 108.302 142.211Z",
    fill: "#D7D7DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.302 142.211H91.9995C91.3883 142.211 90.8896 142.71 90.8896 143.321C90.8896 143.932 91.3883 144.431 91.9995 144.431H108.302C108.913 144.431 109.412 143.932 109.412 143.321C109.412 142.71 108.913 142.211 108.302 142.211Z",
    fill: "url(#paint3_linear_22134_59490)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.751 124.564H124.524C123.913 124.564 123.414 125.063 123.414 125.674C123.414 126.286 123.913 126.784 124.524 126.784H150.751C151.362 126.784 151.861 126.286 151.861 125.674C151.861 125.063 151.362 124.564 150.751 124.564Z",
    fill: "#D7D7DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.751 124.564H124.524C123.913 124.564 123.414 125.063 123.414 125.674C123.414 126.286 123.913 126.784 124.524 126.784H150.751C151.362 126.784 151.861 126.286 151.861 125.674C151.861 125.063 151.362 124.564 150.751 124.564Z",
    fill: "url(#paint4_linear_22134_59490)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_22134_59490)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.8525,
    cy: 82.5,
    rx: 48.5,
    ry: 63,
    transform: "rotate(90 78.8525 82.5)",
    fill: "url(#paint5_linear_22134_59490)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22134_59490)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22134_59490)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_22134_59490)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_22134_59490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.583 62.4041C138.926 62.4041 141.979 61.4726 144.508 59.2895C144.508 59.2895 152.445 49.2468 150.061 45.0551C149.683 44.3856 148.608 43.8034 146.805 43.5123C126.366 40.223 119.418 66.7123 119.418 66.7123C119.418 66.7123 121.133 68.8373 124.36 70.5547C124.36 70.5547 134.74 76.5221 140.002 75.4159C143.287 74.7173 143.229 72.2139 142.735 70.4092C140.583 70.6711 138.926 69.54 136.688 68.488C138.752 69.1575 140.671 70.0598 142.822 70.3509C151.282 66.0137 144.479 59.3186 144.479 59.3186C142.486 61.5194 138.926 63.3018 135.554 62.4333L135.583 62.4041Z",
    fill: "url(#paint6_linear_22134_59490)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_22134_59490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6956 62.4403C30.3521 62.4403 27.2995 61.5088 24.7701 59.3256C24.7701 59.3256 16.8331 49.2829 19.2171 45.0912C19.595 44.4217 20.6707 43.8395 22.4733 43.5484C42.9118 40.2591 49.8604 66.7484 49.8604 66.7484C49.8604 66.7484 48.145 68.8734 44.9179 70.5908C44.9179 70.5908 34.5387 76.5582 29.2764 75.4521C25.9911 74.7534 26.0493 72.2501 26.5435 70.4453C28.695 70.7073 30.3526 69.5761 32.5908 68.5241C30.5266 69.1936 28.6078 70.096 26.4563 70.3871C17.996 66.0498 24.7991 59.3547 24.7991 59.3547C26.7923 61.5555 30.3526 63.3379 33.7247 62.4694L33.6956 62.4403Z",
    fill: "url(#paint7_linear_22134_59490)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_iii_22134_59490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.851 74.6268C125.269 60.2178 116.925 49.5347 102.33 44.5861C96.2541 42.5194 89.7998 41.5879 81.4558 41.5879C72.3268 41.5879 63.4013 44.4988 60.8719 45.3721C49.7949 49.2727 42.294 58.0346 40.2589 69.4162C39.6774 72.6183 39.3576 75.9076 39.2704 79.1969C39.2122 82.0787 39.3285 84.9605 39.6193 87.8715C39.7356 89.0649 39.91 90.2293 40.0844 91.4228C42.2359 104.9 51.6847 114.594 66.0469 118.029C70.7859 119.135 75.8156 119.688 81.4267 119.688C84.1887 119.688 87.0088 119.571 90.6429 119.309C95.4691 118.931 100.586 117.796 105.441 115.991C116.576 111.916 124.223 102.28 125.415 90.8697C125.502 89.9964 125.589 89.094 125.647 88.1917C125.851 85.4263 125.967 82.5445 125.967 79.5462C125.967 77.9452 125.909 76.3151 125.851 74.6268Z",
    fill: "url(#paint8_linear_22134_59490)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dif_22134_59490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.4193 107.545C76.9711 107.545 73.0462 107.138 69.412 106.265C58.5677 103.674 55.2824 96.8332 54.4393 91.5354C53.5089 85.7426 53.5671 79.9499 54.5556 74.3901C55.6604 68.2189 59.6143 63.6488 65.6906 61.4947C67.0862 60.9999 74.4417 58.5547 81.4484 58.5547C88.2515 58.5547 93.1068 59.2242 97.6713 60.767C106.539 63.7652 110.987 69.296 111.336 77.6212C111.539 82.7444 111.423 87.3728 110.958 91.7682C110.347 97.7065 106.393 102.539 100.433 104.722C96.7991 106.061 93.0196 106.905 89.5308 107.167C86.3036 107.4 83.8033 107.516 81.4193 107.516V107.545ZM76.0989 88.8573C76.0989 88.8573 76.2443 88.8864 76.3315 88.9155L76.0989 88.8573Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4193 107.545C76.9711 107.545 73.0462 107.138 69.412 106.265C58.5677 103.674 55.2824 96.8332 54.4393 91.5354C53.5089 85.7426 53.5671 79.9499 54.5556 74.3901C55.6604 68.2189 59.6143 63.6488 65.6906 61.4947C67.0862 60.9999 74.4417 58.5547 81.4484 58.5547C88.2515 58.5547 93.1068 59.2242 97.6713 60.767C106.539 63.7652 110.987 69.296 111.336 77.6212C111.539 82.7444 111.423 87.3728 110.958 91.7682C110.347 97.7065 106.393 102.539 100.433 104.722C96.7991 106.061 93.0196 106.905 89.5308 107.167C86.3036 107.4 83.8033 107.516 81.4193 107.516V107.545ZM76.0989 88.8573C76.0989 88.8573 76.2443 88.8864 76.3315 88.9155L76.0989 88.8573Z",
    fill: "url(#paint9_radial_22134_59490)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.99 79.4218C106.729 72.8053 103.217 69.3519 96.6298 67.1173C92.4799 65.7244 87.8948 65.0859 81.3653 65.0859C75.9676 65.0859 69.6702 66.8271 66.6521 67.8719C62.3862 69.3809 59.6293 72.457 58.8458 76.81C57.8881 82.1787 57.8881 87.6055 58.7297 92.9742C59.6873 99.0684 64.0694 102.173 69.9894 103.566C76.4319 105.105 82.9904 104.901 89.4909 104.408C92.8572 104.147 96.2815 103.305 99.4447 102.144C103.449 100.664 106.177 97.6464 106.613 93.5255C107.106 88.8533 107.164 84.094 106.99 79.3638V79.4218Z",
    fill: "url(#paint10_linear_22134_59490)",
    stroke: "url(#paint11_linear_22134_59490)",
    strokeWidth: 1.14541
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.2733,
    y1: 90.6017,
    x2: 87.0336,
    y2: 90.6017,
    stroke: "url(#paint12_radial_22134_59490)",
    strokeWidth: 1.2809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 67.334 84.9697)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 67.334 84.9697)",
    fill: "url(#paint13_radial_22134_59490)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 70.1016 87.7383)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 70.1016 87.7383)",
    fill: "url(#paint14_radial_22134_59490)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 72.8691 84.9697)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 72.8691 84.9697)",
    fill: "url(#paint15_radial_22134_59490)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 89.4805 84.9697)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 89.4805 84.9697)",
    fill: "url(#paint16_radial_22134_59490)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 92.251 87.7383)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 92.251 87.7383)",
    fill: "url(#paint17_radial_22134_59490)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 95.0176 84.9697)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7684,
    height: 2.7684,
    transform: "matrix(1 0 0 -1 95.0176 84.9697)",
    fill: "url(#paint18_radial_22134_59490)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.8022,
    cy: 91.0244,
    r: 1.27268,
    transform: "rotate(-4.21204 65.8022 91.0244)",
    fill: "url(#paint19_linear_22134_59490)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5014,
    cy: 90.9609,
    r: 1.27268,
    transform: "rotate(-4.21204 99.5014 90.9609)",
    fill: "url(#paint20_linear_22134_59490)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_iii_22134_59490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.0023 113.279C94.4499 115.346 93.7522 117.412 92.9091 119.45C92.7055 119.916 92.2404 120.265 91.6589 120.381C85.6698 121.517 79.5353 121.517 73.5462 120.381C72.9648 120.265 72.4996 119.916 72.2961 119.45C71.4529 117.412 70.7552 115.346 70.2028 113.279C69.9411 112.26 70.9296 111.387 71.9181 111.678C78.8957 113.57 86.2513 113.57 93.2289 111.678C94.2464 111.387 95.2058 112.26 94.9442 113.279H95.0023Z",
    fill: "url(#paint21_linear_22134_59490)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.0722 56.5254C86.7348 56.5254 86.6476 56.4672 86.415 55.2155C85.601 50.6163 81.8505 48.1129 77.7221 47.327C77.4314 47.2687 77.1116 47.2396 76.8208 47.2105C75.687 47.0359 75.7742 46.4537 75.8033 46.2499C75.8033 45.9297 75.8033 45.6386 75.9196 45.3184C76.0649 44.7653 76.6173 44.7945 76.879 44.8236C82.4901 45.2893 86.6185 47.6472 88.8572 52.7704C89.177 53.4981 89.3224 54.284 89.4677 55.0409C89.7294 56.3508 89.5259 56.5254 88.1303 56.5254H88.0722Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0722 56.5254C86.7348 56.5254 86.6476 56.4672 86.415 55.2155C85.601 50.6163 81.8505 48.1129 77.7221 47.327C77.4314 47.2687 77.1116 47.2396 76.8208 47.2105C75.687 47.0359 75.7742 46.4537 75.8033 46.2499C75.8033 45.9297 75.8033 45.6386 75.9196 45.3184C76.0649 44.7653 76.6173 44.7945 76.879 44.8236C82.4901 45.2893 86.6185 47.6472 88.8572 52.7704C89.177 53.4981 89.3224 54.284 89.4677 55.0409C89.7294 56.3508 89.5259 56.5254 88.1303 56.5254H88.0722Z",
    fill: "url(#paint22_linear_22134_59490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7568 56.494C81.5066 56.494 81.5357 56.494 81.245 55.3588C80.7216 53.4667 79.3552 52.3605 77.4363 51.7784C77.2619 51.7201 77.0584 51.691 76.884 51.6619C75.7792 51.429 75.6047 51.2253 75.7501 50.2065C75.8373 49.5952 76.1571 49.2459 76.8549 49.2167C79.5587 49.1585 81.5357 50.4393 83.0184 52.4188C83.6871 53.292 84.0651 54.3691 84.3558 55.5043C84.5012 56.1156 84.2104 56.4649 83.4836 56.494C83.251 56.494 83.0184 56.494 82.7858 56.494H82.7568Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7568 56.494C81.5066 56.494 81.5357 56.494 81.245 55.3588C80.7216 53.4667 79.3552 52.3605 77.4363 51.7784C77.2619 51.7201 77.0584 51.691 76.884 51.6619C75.7792 51.429 75.6047 51.2253 75.7501 50.2065C75.8373 49.5952 76.1571 49.2459 76.8549 49.2167C79.5587 49.1585 81.5357 50.4393 83.0184 52.4188C83.6871 53.292 84.0651 54.3691 84.3558 55.5043C84.5012 56.1156 84.2104 56.4649 83.4836 56.494C83.251 56.494 83.0184 56.494 82.7858 56.494H82.7568Z",
    fill: "url(#paint23_linear_22134_59490)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_22134_59490",
    x: 0.000265121,
    y: 18.1477,
    width: 157.705,
    height: 128.705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.92614,
    result: "effect1_foregroundBlur_22134_59490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_22134_59490",
    x: 18.7705,
    y: 43.2295,
    width: 131.737,
    height: 34.9295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.57009
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28505
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_22134_59490",
    x: 116.304,
    y: 37.0022,
    width: 34.2035,
    height: 41.6641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.11364,
    dy: 3.11364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.55682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.22727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.11364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59490",
    result: "effect2_innerShadow_22134_59490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_22134_59490",
    x: 15.6569,
    y: 37.0384,
    width: 34.2035,
    height: 41.6641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.11364,
    dy: 3.11364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.55682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.22727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.11364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59490",
    result: "effect2_innerShadow_22134_59490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_iii_22134_59490",
    x: 39.2559,
    y: 37.7039,
    width: 86.7109,
    height: 86.8385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.91298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.88397
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.88397
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.82595
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.775729 0 0 0 0 0.439322 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59490",
    result: "effect2_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.85496
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.82595
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_59490",
    result: "effect3_innerShadow_22134_59490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dif_22134_59490",
    x: 46.9228,
    y: 48.2743,
    width: 68.7923,
    height: 63.5541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.7134,
    dy: -5.14019
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.57009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22134_59490",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.7134,
    dy: 1.7134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.507625 0 0 0 0 0.507625 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.14175,
    result: "effect3_foregroundBlur_22134_59490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iii_22134_59490",
    x: 70.1602,
    y: 108.708,
    width: 24.8418,
    height: 15.4383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.91298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.88397
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.91298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.91298
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.855364 0 0 0 0 0.638409 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59490",
    result: "effect2_innerShadow_22134_59490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.94198
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.91298
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_59490",
    result: "effect3_innerShadow_22134_59490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22134_59490",
    x1: 23.3089,
    y1: 119.401,
    x2: 23.3087,
    y2: 123.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22134_59490",
    x1: 35.6631,
    y1: 109.223,
    x2: 35.6631,
    y2: 111.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22134_59490",
    x1: 113.901,
    y1: 133.401,
    x2: 113.901,
    y2: 137.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22134_59490",
    x1: 100.9,
    y1: 142.434,
    x2: 100.9,
    y2: 144.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22134_59490",
    x1: 138.788,
    y1: 124.787,
    x2: 138.788,
    y2: 126.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22134_59490",
    x1: 78.8525,
    y1: 19.5,
    x2: 390.638,
    y2: 368.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFADA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22134_59490",
    x1: 136.221,
    y1: 46.4708,
    x2: 136.204,
    y2: 77.6072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22134_59490",
    x1: 33.0577,
    y1: 46.507,
    x2: 33.0744,
    y2: 77.6433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22134_59490",
    x1: 82.6036,
    y1: 50.0471,
    x2: 82.6036,
    y2: 124.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-41.4363 11.7363 -13.8121 -35.2089 101.072 74.214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22134_59490",
    x1: 82.6478,
    y1: 63.2021,
    x2: 83.6783,
    y2: 108.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22134_59490",
    x1: 65.7196,
    y1: 62.5941,
    x2: 93.7056,
    y2: 105.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595864,
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#FFF5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.49781 0.239562 -2.16594 -0.718686 86.0495 91.5618)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27097 0.884887) rotate(161.565) scale(2.09723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27097 0.884887) rotate(161.565) scale(2.09723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27097 0.884887) rotate(161.565) scale(2.09723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27097 0.884887) rotate(161.565) scale(2.09723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27097 0.884887) rotate(161.565) scale(2.09723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_22134_59490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27097 0.884887) rotate(161.565) scale(2.09723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22134_59490",
    x1: 65.8022,
    y1: 89.7517,
    x2: 65.8022,
    y2: 92.2971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22134_59490",
    x1: 99.5014,
    y1: 89.6882,
    x2: 99.5014,
    y2: 92.2336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_22134_59490",
    x1: 82.6038,
    y1: 111.541,
    x2: 82.6038,
    y2: 137.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_22134_59490",
    x1: 76.5131,
    y1: 45.3478,
    x2: 75.096,
    y2: 62.4271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_22134_59490",
    x1: 76.1626,
    y1: 49.5487,
    x2: 75.2946,
    y2: 60.1632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22134_59490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 137,
    fill: "white",
    transform: "translate(16.3525 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22134_59490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 80.4875,
    fill: "white",
    transform: "translate(16.3525 40.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAttachment);
export default __webpack_public_path__ + "static/media/icon-no-attachment.2f105cf83ae3323a1865c22bc1abda4f.svg";
export { ForwardRef as ReactComponent };